import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-scans-per-day',
  templateUrl: './scans-per-day.component.html',
  styleUrls: ['./scans-per-day.component.css']
})
export class ScansPerDayComponent implements OnInit {
  @Input() entityDetails: any;
  @Input() widgetData: any;
  @Input() entityId: string;
  
  constructor() { }

  ngOnInit(): void {
  }

}
